import { AfterViewInit, Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[first-focus]'
})
export class FirstFocusDirective implements AfterViewInit {

  constructor(private elementRef: ElementRef) { }
    
  ngAfterViewInit() {
    this.elementRef.nativeElement.focus();
  }
    
}